export const AI_COLORS = {
  lighter: '#F9D4FF',
  light: '#EB71FF',
  main: '#9C3CAC',
  dark: '#7D1F8D',
  darker: '#660376',
};
